import React from "react";

import "./Shares.scss"
import { isMobile, isIos } from "../../static/helper";
import { GA_Event } from "../Analytics/Analytics";

function Shares(props) {
  const shareUrl = 'https://z.ynet.co.il/mshort/content/DecadeParade';

  const shareFacebook = () => {
    window.open("https://www.facebook.com/share.php?u=" + shareUrl, '_blank', "width=500,height=300");
    GA_Event('Share_Events', 'Decade Parade', 'Social - Share Facebook', props.label);
    // this.props.sendGA("Share_Facebook", shareUrl);
  }

  const shareWhatsapp = () => {
    let url = '';
    if (isMobile() || isIos()) {
      url = `whatsapp://send?text=${shareUrl}`;
      window.open(url, "_parent");
    } else {
      url = `https://api.whatsapp.com/send?phone=&text=${shareUrl}`
      window.open(url, "_blank");
    }
    GA_Event('Share_Events', 'Decade Parade', 'Social - Share Whatsapp', props.label);
    // let url = `whatsapp://send?text=${shareUrl}`;
    // window.open(url, '_blank', "width=500,height=300");
    // this.props.sendGA("Share_Whatsapp", url);
  }

  const shareTwitter = () => {
    let title = "מצעד העשור – ynet";
    let description = '2020 עוד רגע כאן – וזה הזמן להכתיר את השירים, הסרטים וסדרות הטלוויזיה שעשו לנו את העשור האחרון. יחד עם צוות השופטים של ynet ומוסף "7 לילות" של "ידיעות אחרונות" – גם אתם תקבעו את התוצאות. אז קדימה, הצביעו והשפיעו!';
    let url = 'https://twitter.com/intent/tweet?text=' + title + " " + description + "%0A" + shareUrl;
    window.open(url, '_blank', "width=500,height=300");
    GA_Event('Share_Events', 'Decade Parade', 'Social - Share Twitter', props.label);
    // this.props.sendGA("Share_Twitter", shareUrl);
  }

  return (
    <div className="shares-container">
      <div className="whatsapp" onClick={shareWhatsapp}></div>
      <div className="twitter" onClick={shareTwitter}></div>
      <div className="facebook" onClick={shareFacebook}></div>
    </div>
  );
}

export default Shares;
